import { EMAIL_SUBSCRIPTION } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { getBaseEventBasedFilterFamilyField } from '../strategy/eventBasedFilters';
export const useEmailSubscriptionFilter = condition => {
  const statusCondition = condition.set('field', getBaseEventBasedFilterFamilyField(EMAIL_SUBSCRIPTION));
  return {
    statusCondition
  };
};